import DropDownList from "saur_ui_library/src/Molecules/DropDownList/DropDownList";
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import React, { FC, useEffect, useRef } from "react";
import styled ,{ createGlobalStyle }from "styled-components";
// import from "styled-components";
import { ImportApi } from "../../utils/api";
import { Toast } from "primereact/toast";
import ReactFileReader from "react-file-reader";
import Group from "../../assets/Group.svg";

type ImportProps = {
  IsVisible: any;
  setModalVisible: any;
};
type formType = {
  module: null | any;
  type: null | any;
};
const Import: FC<ImportProps> = (props) => {
  //Reset
  useEffect(() => {
    setForm(() => ({
      module: null,
      type: null,
    }));
  }, [props.IsVisible]);

  //Form fields
  const [, setForm] = React.useState<formType>({
    module: null,
    type: null,
  });

  //Variable for the charged data
  // const [error, setError] = React.useState(false);
  const toastSucess = useRef<any>(null);
  const toastInfo = useRef<any>(null);
  const toastError = useRef<any>(null);
  const [fileName, setFileName] = React.useState("");
  const [fileResult, setFileResult] = React.useState<any>("");

  //function de suppression 
  const deletion = ()=>{
    setFileName("");
    setFileResult("");
  }

  //type de données pour l'instant déclaratives

  const handleOnSubmit = async (files) => {
    let reader = new FileReader();
    //chargement
    reader.onload = async function (e) {
      setFileResult(reader.result);
    };
    reader.readAsText(files[0]);
    //fin du chargement pour récupérer le nom du fichier
    reader.onloadend = (function (file) {
      return function (evt) {
        createListItem(evt, file);
      };
    })(files[0]);

    function createListItem(evt, file) {
      console.log(evt.target.result);
      setFileName(file.name);
    }
  };

  async function beforeSubmit() {
    //pour l'instant H2s uniquement
    if (fileName) {
      try {
        await ImportApi.ImportCsv(fileResult).then((value: any) => {
          if (value.status === 200) {
            if(value.data.length){
              toastInfo.current?.show({
                severity: "info",
                summary: "Ligne(s) rejetée(s)",
                detail: " Les lignes "+value.data.join(', ')+" de votre fichier n'ont pas été enregistrées. ",
                sticky:true
              });
            }
            else{
              toastSucess.current?.show({
                severity: "success",
                summary: "Succès",
                detail: "Fichier enregistrée avec succès",
                life: 5000,
              });
            }
          }
        });
        //then delete file and file name
        deletion();
      } catch (e) {
        toastError.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: "Votre fichier semble présenter une erreur. Veuillez réessayer. ",
          life: 5000,
        });

        console.log(e)
      }
    }
  }

  const popupContent = () => (
    <Container className='modalSizeContainer'>
      <Form onSubmit={beforeSubmit}>
        <Container className='modules'>
          <Word
            className='module-title-text'
            value='Modules'
            automatedTestId='module-title-text'
            textStyle='normalReg'
            variant='p'
          />
          <DropDownList
            className='module-dropdown'
            placeHolder='Modules'
            onChange={(value) => {
              setForm((oldValues) => {
                return { ...oldValues, module: value };
              });
            }}
            values={[
              {
                id: 1,
                label: 'H2S',
                value: 'H2S',
                automatedTestId: 'module-h2s',
              },
            ]}
          />
        </Container>
        <Container className='dataType'>
          <Word
            className='dataType-title-text'
            value='Type de données'
            automatedTestId='dataType-title-text'
            textStyle='normalReg'
            variant='p'
          />
          <DropDownList
            onChange={(value) => {
              setForm((oldValues) => {
                return { ...oldValues, type: value };
              });
            }}
            placeHolder='Types de données'
            className='dataType'
            values={[
              {
                id: 0,
                label: 'Données déclaratives',
                value: 'declaratives',
                automatedTestId: 'donnees-declaratives',
              },
              {
                id: 1,
                label: 'Données de Télégestion ',
                value: 'telegestion',
                automatedTestId: 'donnees-telegestion',
              },
            ]}
          />
        </Container>
        <Word
          className='files-title-text'
          value='Fichiers'
          automatedTestId='files-title-text'
          textStyle='normalReg'
          variant='p'
        />
        <Container className='bottom-align'>
          <Container className='filestButton' automatedTestId='filestButton'>
            <ReactFileReader
              id='import-csv-reader'
              handleFiles={handleOnSubmit}
              fileTypes={'.csv'}
            >
              <Button
                className='files-text-btn'
                automatedTestId='files-text-btn'
                mode='basic'
              >
                <Word
                  variant='span'
                  textStyle='normalBold'
                  value='Déposer des fichiers ou Ajouter'
                  automatedTestId='files-text-btn-text'
                />
              </Button>
            </ReactFileReader>
          </Container>
          {fileName ? (
            <Container
              className='file-delete-btn'
              automatedTestId='file-delete-btn'
            >
              <Container className='logo'>
                <a href='/DO'>
                  <img
                    className='file-logo'
                    id='file-logo'
                    alt='logo'
                    src={Group}
                  ></img>
                </a>
              </Container>
              <Word
                className='files-name-text'
                value={fileName}
                automatedTestId='file-name-text'
                textStyle='normalReg'
                variant='p'
              />
              <Button
                className='delete-btn'
                automatedTestId='delete-btn'
                mode='basic'
                onClick={() => {
                  deletion();
                }}
              >
                <Word
                  variant='span'
                  automatedTestId='delete-btn-text'
                  textStyle='normalBold'
                  value='Supprimer'
                />
              </Button>
            </Container>
          ) : null}
        </Container>
        <Container className='formButton'>
          {
            <StyledSectionButton>
              <Button
                automatedTestId='import-btn'
                className='import-btn'
                mode='plain'
              >
                <Word
                  variant='span'
                  textStyle='normalBold'
                  value='Importer'
                  automatedTestId='import-btn-text'
                />
              </Button>
            </StyledSectionButton>
          }
        </Container>
      </Form>
    </Container>
  );

  //Html
  return (
    <Container className="global-Import-container">
      <Styles />
      <Toast id="toast-success" ref={toastSucess} />
      <Toast id="toast-info" ref={toastInfo} />
      <Toast id="toast-error" ref={toastError} />
      <ModalFlexible
        showHeader
        className="ImportContainer"
        title="Import de données"
        toggleModal={props.setModalVisible}
        visible={props.IsVisible}
        desktopContent={popupContent}
      />
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
`;
const Styles = createGlobalStyle`
  .sds-reset-style{
    .bottom-align{
      flex-direction: row;
      .filestButton{
       width: 25%;
       justify-content: space-around;
      }
      .file-delete-btn{
       margin-left: 20px;
       justify-content: space-around;
       
      }
      .files-name-text,.logo{
      height: 100%;
      vertical-align: middle;
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
      margin: auto;
      }
    }
    .dataType, .modules{
      margin-bottom: 15px;
    }
    .dropdown-icon-container path{
      fill: #008BD2;
    }
    .delete-btn{
      text-decoration: underline;
      margin-left:5px;
    }
    .file-delete-btn{
      flex-direction: row;
    }
    .filestButton {
      border: 2px solid #63D1B4;
      border-radius: 24px;
      width: 218px;
      height: 121px;
      border-style: dashed;
      .files-text-btn{
        align-self:center;
      }
    }
    .ImportContainer{
      z-index:200;  
      div.modal-flex-desktop-content{
      width: 100vh;
    }
    .import-btn{
      margin-left: auto;
      margin-right: auto
    }
    .modalSizeContainer{
    margin-bottom: 2%;
    color: black !important;
      .dropdown-icon-container svg{
        width:15px;
      }
    } 
    }
    .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
      align-items: flex-end !important;
      padding: 0px !important;
      height: max-content;
      flex-direction: column !important;
    }
    .sds-word.title.modal-flex-desktop-content-title {
      color: black !important;
    }
    .modal-flex-mobile-header{
      display: none;
    }  
  }
  `;
export default Import;
